<script lang="ts">
	import type { HolsterLineResponse } from '../../../build_holsters_page'

	import HolsterLine from './HolsterLine.svelte'

	export let promo_active: boolean = false
	export let holster_lines: HolsterLineResponse
</script>

<ol>
	{#each holster_lines as holster_line}
		<HolsterLine
			{holster_line}
			{promo_active}
		/>
	{/each}
</ol>

<style>
	ol {
		--contrast-text: #fff;
		--contrast-gray: #b3b3b3;
		--disabled-gray: #686868;
		--trex-green: #CEFF51;
		--black: #141414;

		list-style-type: none;
		font-size: 1rem;
		color: var(--contrast-gray);

		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	ol, ol :global(li > *) {
		margin: 0;
	}

	ol :global(li > *) {
		font-size: 1rem;
	}
</style>
